<template>
  <div class="standing">
    <div class="standing_query lading_conter_search" id="lading_conter_search">
      <my-search-query :fromList="fromList" @queryEven="getTableParams(false, 'reset')" ref="queryList"/>
    </div>
    <div class="standing-bar">
      <search>
        <el-button type="primary" size="small" @click.native="operationInfoEven" icon="el-icon-tickets"> 详情</el-button>
        <!--<el-button type="primary" size="small" @click.native="operationAddEven" icon="el-hg-icon-add"> 新增</el-button>-->
        <el-dropdown >
          <el-button type="primary" size="small" icon="el-hg-icon-add"> 新增</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-permission="'1107'" @click.native="operationAddEven('lading')">新增装车提单</el-dropdown-item>
            <el-dropdown-item v-permission="'1108'" @click.native="operationAddEven('unload')">新增卸车提单</el-dropdown-item>
            <el-dropdown-item v-permission="'1109'" @click.native="operationAddEven('ladingShip')">新增装船提单</el-dropdown-item>
            <el-dropdown-item v-permission="'1110'" @click.native="operationAddEven('unladingShip')">新增卸船提单</el-dropdown-item>
            <el-dropdown-item v-permission="'1111'" @click.native="operationAddEven('ladingPipe')">新增管线进提单</el-dropdown-item>
            <el-dropdown-item v-permission="'1112'" @click.native="operationAddEven('unladingPipe')">新增管线出提单</el-dropdown-item>
            <el-dropdown-item v-permission="'1113'" @click.native="operationAddEven('ladingTransfer')">新增转罐提单</el-dropdown-item>
            <el-dropdown-item v-permission="'1114'" @click.native="operationAddEven('ladingOther')">新增其他提单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-permission="'1102'" type="primary" size="small" :disabled="disableBtnedit"
                   @click.native="operationEditEven" icon="el-hg-icon-edit"> 修改
        </el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-audit" @click="btnConfirm(doAudit,'是否审核选中提单？')"
                   v-permission="'1105'"
                   :disabled="disableBtnaudit">审核
        </el-button>
        <el-button type="danger" size="small" @click.native=" btnConfirm(operationDeleteEven,'是否作废选中提单？')"
                   icon="el-hg-icon-delete"
                   v-permission="'1103'"
                   :disabled="disableBtnDel"> 作废
        </el-button>
        <el-button type="danger" size="small" @click.native=" btnConfirm(operationRevokeEven,'是否作废选中提单？')"
                   icon="el-icon-remove"
                   v-permission="'1106'"
                   :disabled="disableBtnRevoke"> 退审
        </el-button>
        <el-button type="primary" size="small" @click.native="getTableParams(false)" icon="el-icon-refresh">刷新
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-upload" @click="$refs.spTable.exportExcel()">导出</el-button>
      </search>
    </div>
    <div class="lading_conter">
      <div class="lading_table">
        <div class="lading_conter_table">
          <sp-table
            ref="spTable"
            :parentTableData.sync="tableData"
            :parentCol.sync="colList"
            :dragDrop=true
            :id-edit="false"
            @addNewData="addNewData"
            @selection-change="handleSelectionChange"
            @getDetail="operationInfoEven"
            width="100%"
            :summary-method="getSummaries"
            :summary-data="summaryData"
            show-summary
            @header-click="headerClickEven"
          >
            <el-table-column align="center" type="selection" class="selection" width="70"></el-table-column>
            <el-table-column align="center" type="index" label="序号" width="50" class-name="index"></el-table-column>
            <sp-table-column :align="item.titleAlignment" v-for="(item, index) in colList" :key="`col_${index}`"
                             :width="item.width" :sortable="colList[index].sortableStart"
                             :sort-orders="['ascending','descending',null]" :prop="colList[index].field">
              <template slot="header">
                <p :class="item.field">{{item.title}}</p>
              </template>
              <template v-slot="{ scope }">
                <div class="span" :style="{ textAlign: item.alignment}" :class="[initColor(scope.row),'span']">
                  {{item.id ? item.id : item.uid}}
                  {{scope.row[colList[index].field]}}
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
        <div class="page">
          <page-modle :currentPage.sync="currentPage" :total="total" :pageSize.sync="pageSize"
                      @currentChange="currentChange" @sizeChange="sizeChange"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {spTable, spTableColumn} from '@/components/sptable';
  import pageModle from '@/views/comm/pagination';
  import mySearchQuery from './comm/searchQuery';
  import Search from 'views/comm/search';
  import {mapGetters, mapActions} from 'vuex';
  import dayjs from 'dayjs';
  import storageM from '@/storage';

  const storage = storageM['sessionStorage'];
  const _ = require('lodash');

  export default {
    name: 'billLading',
    components: {
      spTable,
      spTableColumn,
      mySearchQuery,
      pageModle,
      Search,
    },
    data() {
      return {
        tableData: [],
        bargain: [],
        productNumList: [],
        getTGuestNumList: [],
        getBlno: [],
        getCreator: [],
        heightSearch: 0,
        currentPage: 1,
        pageSize: 10,
        total: 0,
        queryAPIstart: false,
        userChoice: [],
        addOperationStart: false,
        colList: [],
        getDateTimeTypeData: [],
        serviceId: ['', ''],
        serviceIdList: [],
        billlist: [],
        disableBtnDel: false,
        disableBtnedit: false,
        disableBtnaudit: false,
        disableBtnRevoke: false,
        summaryData: '',
        orderType: [],
      };
    },
    updated() {
      // let height = this.$refs.spTable.$el.clientHeight;
      // this.heightSearch = height > 592 ? height : 592;
    },
    // 修改提单明细时，切换到台账会更新台账数据
    activated() {
      let start = storage.$get({key: 'customerServiceTable',});
      if (start) {
        storage.$remove({
          key: 'customerServiceTable',
        });
        this.getTableParams(false);
      }
    },
    async mounted() {
      // this.$refs.queryList.resizeSearch();
      await this.allQueryAPI();
      this.initCol();
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        controllerList: 'dictionary/controllerList',
        visitedViews: 'tags/visitedViews',
      }),
      fromList() {
        // 搜索栏位条件
        // label文案提示
        // key对应搜索接口的对应key值
        // type组件类型
        // valData下拉组件数组
        // labelVal下拉组件对应文字内容
        // ServiceID对应绑定值
        // multiple开启下拉组件的搜索
        // tips弹窗框组合组件的按钮文案
        // dialog弹窗框组合组件的绑定之判断是否开启弹窗
        // code弹窗框组合组件table对应的数据字典编号
        // default组件的默认输入值
        let arr = [
          {label: '订单号', key: 'mainOrderId', type: 'input'},
          {
            label: '类别',
            key: 'serviceId',
            type: 'select',
            valData: this.serviceIdList,
            labelVal: 'ServiceName',
            value: 'ServiceID',
            multiple: true,
            colSpan: 8
          },
          {label: '客户', key: 'TGuestName', type: 'input', tips: '...', dialog: 'showGuestId', code: 4000},
          {
            label: '单据状态',
            key: 'state',
            type: 'checkbox',
            valData: this.billlist,
            labelVal: 'value',
            value: 'key',
            multiple: true,
            default: ['0', '90', '91']
          },
          {
            label: '合同',
            key: 'bargainId',
            type: 'input',
            tips: '...',
            dialog: 'showBargainID',
            code: 3052,
            valData: this.bargain,
            labelVal: 'BargainID',
            value: 'BargainID'
          },
          {
            label: '产品',
            key: 'goodsName',
            type: 'input',
            showDialog: true,
            tips: '...',
            dialog: 'showGoodsID',
            code: 4002
          },
          {
            label: '提货人',
            key: 'Name',
            valData: this.getTGuestNumList,
            type: 'input',
            tips: '...',
            dialog: 'showgetTGuest',
            labelVal: 'LinkMan',
            value: 'GuestID',
            code: 3000
          },
          {label: '提单号', key: 'blno', valData: this.getBlno, type: 'input', labelVal: 'BLNO', value: 'BLNO'},
          {
            label: '制表人',
            key: 'operatorId',
            type: 'select',
            valData: this.getCreator,
            labelVal: 'name',
            value: 'operatorid'
          },
          {
            label: '日期类别',
            key: 'dateTimeType',
            type: 'select',
            default: 'createDate',
            valData: this.getDateTimeTypeData,
            labelVal: 'value',
            value: 'key'
          },
          {
            label: '开始时间',
            key: 'beginDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByMonth(new Date(), 1)} 00:00:01`,
          },
          {
            label: '结束时间',
            key: 'endDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByDay(new Date())} 23:59:59`
          },
        ];
        return arr;
      },
    },
    methods: {
      headerClickEven(column, event) {
        this.colList.forEach((itme, key) => {
          if (column.property === itme.field) {
            !itme.sortableStart ? column.order = 'ascending' : '';
            itme.sortableStart = true;
            if (column.order === null) {
              itme.sortableStart = false;
              column.order = '';
            }
            this.$forceUpdate();
          }
        });
      },
      // 获取单据状态
      getStateList() {
        return new Promise((resolve, rej) => {
          this.$services.post({
            type: 'BUSINESS',
            url: 'getStateList',
            params: {
              accountId: this.userInfor.accountId,
            },
          }).then(res => {
            this.billlist = res.bean;
            resolve();
          });
        });

      },
      // 获取服务编号
      getServiceIdAPI(type) {
        return new Promise((resolve, rej) => {
          this.$services.post({
            type: 'BUSINESS',
            url: 'getServiceIdWeb',
            params: {
              accountId: this.userInfor.accountId,
              orderType: type,
            },
          }).then(res => {
            this.serviceIdList=res.bean;
            if (this.serviceIdList.length > 1) {
            }
            // this.getTableParams(false);
            resolve();
          });
        });
      },
      addNewData(callback) {
        this.tableData.push(JSON.parse(JSON.stringify(
          Object.assign({
            uid: this.$utils.getUid(),
          }, this.originData),
        )));
        this.$nextTick(() => {
          callback();
        });
      },
      // 获取日期类别
      getDateTimeType() {
        this.$services.post({
          type: 'BUSINESS',
          url: 'getDateTimeType',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.getDateTimeTypeData = res.bean;
        });
      },
      // 导出事件
      exportEven() {

      },
      getSummaries(param) {
        const countList = ['BLNumber', "RealNumber", "LeftNumber"];
        const countObj = {
          BLNumber: {
            unit: ' ',
          }, RealNumber: {
            unit: ' ',
          }, LeftNumber: {
            unit: ' ',
          },
        };
        const {columns, data} = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (countObj[column.property]) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                }
                return prev;
              }, 0);
              sums[index] += countObj[column.property].unit;
            }
            else {
              sums[index] = '';
            }
          }
        });
        this.summaryData = [countList, sums];
        return sums;
      },
      // 条件事件集合
      async allQueryAPI() {
        await this.getDateTimeType();
        await this.getBargainEven();
        await this.getBlnoEven();
        // await this.productNum();
        await this.getTGuestNum();
        await this.getCreatorEven();
        let res = await this.getOrderType();
        if (res) {
          Promise.all([this.getStateList(), this.getServiceIdAPI(res)]).then(v => {
            this.getTableParams(false);
          });
        }
        this.queryAPIstart = true;
      },
      //
      getOrderType() {
        return new Promise((resolve, reject) => {
          this.$services.post({
            type: 'BUSINESS',
            url: 'getOrderTypeForWeb',
            params: {
              accountId: this.userInfor.accountId,
            },
          }).then(res => {
            res.bean.forEach((v) => {
              this.orderType.push(v.OrderType);
            });
            this.orderType = this.orderType.join(',');
            resolve(this.orderType)
          });
        })
      },
      // 合同号弹出选择
      getBargainEven() {
        this.$services.post({
          type: 'BUSINESS',
          url: 'getBargain',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.bargain = res.bean;
        });
      },
      // 提单号接口
      getBlnoEven() {
        this.$services.post({
          type: 'BUSINESS',
          url: 'getBlno',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.getBlno = res.bean;
        });
      },
      // 制表人接口
      getCreatorEven() {
        this.$services.post({
          type: 'BUSINESS',
          url: 'getCreator',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.getCreator = res.bean;
        });
      },
      // page翻页回调
      currentChange(val) {
        this.currentPage = val;
        this.getTableParams(false);
      },
      // 每页显示数据内容变化
      sizeChange(val) {
        this.pageSize = val;
        this.getTableParams(false);
      },
      // 产品编号
      productNum() {
        this.$services.post({
          type: 'BUSINESS',
          url: 'getGoods',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.productNumList = res.bean;
        });
      },
      // 提货人编号
      getTGuestNum() {
        this.$services.post({
          type: 'BUSINESS',
          url: 'getTGuest',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.getTGuestNumList = res.bean;
        });
      },
      // 获取台帐table数据
      getTableList(params) {
        console.log(params)
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getMainList',
          params,
        }).then(res => {
          this.tableData = res.bean.map(item => {
            item.uid = this.$utils.getUid();
            return item;
          });
          if (this.tableData[0]) {
            this.total = this.tableData[0].OWTableCounts;
          }
          else {
            this.total = 0;
            this.currentPage = 1;
          }
          this.$nextTick(() => {
            this.$refs.spTable.initTable();
          });
        });
      },
      initColor(item) {
        const State = {
          100: 'orderState_color1',
          0: 'orderState_color3',
          1: 'orderState_color10',
          '-1': 'orderState_color4',
          99: 'orderState_color5',
          90: 'orderState_color6',
          91: 'orderState_color7',
        };
        if (item.IsRed === 1) {
          return 'orderState_color8';
        }
        if (State[item.State]) return State[item.State];
        return 'orderState_color9';
      },
      // 台帐参数处理
      getTableParams(start, reset) {
        if (reset === 'reset') this.currentPage = 1;
        let params = {
          // sOperatorId: this.userInfor.id,
          operatorId: this.userInfor.userName,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          accountId: this.userInfor.accountId,
          dateTimeType: 'createDate',
          beginDate: '2019-01-01 00:00:00',
          endDate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        };
        if (!start) {
          let fromData = _.cloneDeep(this.$refs.queryList.fromData);
          if (fromData.serviceId) {
            params.serviceId = fromData.serviceId.join(',');
          }
          else {
            delete fromData.serviceId;
          }
          if (fromData.state[0]) {
            params.state = fromData.state.join(',');
          }
          if (fromData.beginDate) {
            params.beginDate = fromData.beginDate.substring(0, 11) + '23:59:59';
            delete fromData.beginDate;
          }
          if (!fromData.goodsName) fromData.goodsId = '';
          if (!fromData.TGuestName) fromData.vGuestId = '';
          if (!fromData.Name) fromData.tGuestId = '';
          for (let i in fromData) {
            if (!fromData[i] || typeof fromData[i] === 'object') {
              delete fromData[i];
            }
          }
          Object.assign(params, fromData);
        }
        console.log(params)
        this.getTableList(params);
      },
      // 用户勾选数据
      handleSelectionChange(val) {
        this.userChoice = val;
        let DelRE = true, editRE = true, RevokeRE = true;
        val.forEach(v => {
          if (v.State !== 0 && v.State !== 2 && v.State !== 90) {
            this.disableBtnDel = true;
            DelRE = false;
          }
          if (v.State !== 0) {
            this.disableBtnedit = true;
            this.disableBtnaudit = true;
            editRE = false;
          }
          if (v.State !== 90) {
            this.disableBtnRevoke = true;
            RevokeRE = false;
          }
        });
        DelRE ? this.disableBtnDel = false : '';
        editRE ? this.disableBtnedit = false : '';
        editRE ? this.disableBtnaudit = false : '';
        RevokeRE ? this.disableBtnRevoke = false : '';
      },
      // 详情
      operationInfoEven() {
        if (this.userChoice.length > 1 || this.userChoice.length === 0) {
          this.$message({
            type: 'warning',
            message: '请选择一条数据查看',
          });
          return false;
        }
        // ServiceName
        // billLadingUnload
        let serveId=[{id:'08',name:'billLadingUnload'},
          {id:'09',name:'billLadingLading'},
          {id:'06',name:'billLadingUnloadShip'},
          {id:'07',name:'billLadingShip'},
          {id:'14',name:'billLadingPipe'},
          {id:'15',name:'billLadingUnloadPipe'},
          {id:'18',name:'billLadingOther'},
          {id:'20',name:'billLadingTransfer'},
        ];
        serveId.forEach((v)=>{
          if(v.id===this.userChoice[0].ServiceID){
            this.toJupmDetail(v.name);
          }
        });
      },
      toJupmDetail(routerName){
        this.titleChange(routerName);
        this.$router.push({
          name: routerName,
          query: {id: this.userChoice[0].BillID, type: 'info', MainOrder: this.userChoice[0].MainOrderID}
        });
      },
      titleChange(path) {
        this.visitedViews.forEach(v => {
          v.path.indexOf(path) > -1 && v.title.indexOf('新增') > -1 ? v.title = v.title.replace(/新增/, '') + '详情' : '';
        });
      },
      // 添加
      operationAddEven(type) {
        this.$services.postLoading({
          type: 'ERP',
          url: 'getBillId',
          params: {
            tableId: 'MainOrder',
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          let bean = JSON.parse(res.bean);
          let BillID = bean[0].BillID;
          let FieldValue = bean[0].FieldValue;
          if (type === 'lading') {
            this.$router.push({name: 'addBillLadingLading', query: {id: BillID, type: 'add', MainOrder: FieldValue}});
          } else if (type === 'unload') {
            this.$router.push({name: 'addBillLadingUnload', query: {id: BillID, type: 'add', MainOrder: FieldValue}});
          } else if (type === 'ladingShip') {
            this.$router.push({name: 'addBillLadingShip', query: {id: BillID, type: 'add', MainOrder: FieldValue}});
          } else if (type === 'unladingShip') {
            this.$router.push({
              name: 'addBillLadingUnloadShip',
              query: {id: BillID, type: 'add', MainOrder: FieldValue}
            });
          } else if (type === 'ladingPipe') {
            this.$router.push({name: 'addBillLadingPipe', query: {id: BillID, type: 'add', MainOrder: FieldValue}});
          } else if (type === 'unladingPipe') {
            this.$router.push({
              name: 'addBillLadingUnloadPipe',
              query: {id: BillID, type: 'add', MainOrder: FieldValue}
            });
          } else if (type === 'ladingTransfer') {
            this.$router.push({name: 'addBillLadingTransfer', query: {id: BillID, type: 'add', MainOrder: FieldValue}});
          } else if (type === 'ladingOther') {
            this.$router.push({name: 'addBillLadingOther', query: {id: BillID, type: 'add', MainOrder: FieldValue}});
          }
        });
      },
      btnConfirm(F, str, par) {
        this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof F === "function") F(par);
        });
      },
      //审核
      doAudit() {
        this.userChoice.forEach(itme => {
          let Step = '';
          this.$services.post({
            type: 'ERP',
            url: 'getCheckChecking',
            params: {
              accountId: this.userInfor.accountId,
              tableId: 'MainOrder',
              billId: itme.BillID,
            },
          }).then(res => {
            if (res.bean) {
              Step = res.bean.length;
            }
            else {
              Step = 0;
            }
            this.$services.post({
              type: 'ERP',
              url: 'doAudit',
              params: {
                pProId: 100001,
                aAccountId: this.userInfor.accountId,
                aTableId: 'MainOrder',
                aBillId: itme.BillID,
                aAuditStep: Step,
                pFuncId: 612,
                aOperatorId: this.userInfor.id,
                pAccountId: this.userInfor.accountId,
              },
            }).then(res => {
              if (typeof res.bean === 'string') {
                let bean = JSON.parse(res.bean);
                if (bean.RetMessage) {
                  this.$message({
                    message: JSON.parse(res.bean).RetMessage,
                    type: 'warning',
                  });
                }
                else {
                  this.$message({
                    message: '审核成功！',
                    type: 'success',
                  });
                }
              }
              this.getTableParams(false);
              this.$forceUpdate();
            });
          });

        });

      },
      // 编辑
      operationEditEven() {
        if (this.userChoice.length > 1 || this.userChoice.length === 0) {
          this.$message({
            type: 'info',
            message: '请选择一条数据修改',
          });
          return false;
        }
        if (this.userChoice[0].ServiceID === '09') {
          this.titleChange('billLadingLading');
          this.$router.push({
            name: 'billLadingLading',
            query: {id: this.userChoice[0].BillID, type: 'edit', MainOrder: this.userChoice[0].MainOrderID}
          });
        }
        else if (this.userChoice[0].ServiceID === '08') {
          this.titleChange('billLadingUnload');
          this.$router.push({
            name: 'billLadingUnload',
            query: {id: this.userChoice[0].BillID, type: 'edit', MainOrder: this.userChoice[0].MainOrderID}
          });
        }
      },
      // 作废
      operationDeleteEven() {
        this.userChoice.forEach(itme => {
          this.$services.postLoading({
            type: 'ERP',
            url: 'doBlankOut',
            params: {
              aAccountId: this.userInfor.accountId,
              aTableId: 'MainOrder',
              aBillId: itme.BillID,
              aAuditStep: 0,
              pFuncId: 410,
              aOperatorId: this.userInfor.id,
              pAccountId: this.userInfor.accountId,
              pProId: 100001,
            },
          }).then(res => {
            if (typeof res.bean === 'string') {
              let bean = JSON.parse(res.bean);
              if (bean.RetMessage) {
                this.$message({
                  message: JSON.parse(res.bean).RetMessage,
                  type: 'warning',
                });
              }
            }
            this.getTableParams(false);
          });
        });
      },
      operationRevokeEven() {
        this.userChoice.forEach(itme => {
          this.$services.postLoading({
            type: 'ERP',
            url: 'doCancleAudit',
            params: {
              aAccountId: this.userInfor.accountId,
              aTableId: 'MainOrder',
              aBillId: itme.BillID,
              aAuditStep: 0,
              aFuncId: 410,
              aOperatorId: this.userInfor.id,
              pAccountId: this.userInfor.accountId,
              pProId: 100001,
              pFuncId: 410,
            },
          }).then(res => {
            if (typeof res.bean === 'string') {
              let bean = JSON.parse(res.bean);
              if (bean.RetMessage) {
                this.$message({
                  message: JSON.parse(res.bean).RetMessage,
                  type: 'warning',
                });
              }
              else {
                this.$message({
                  message: '退审成功！',
                  type: 'success',
                });
              }
            }
            this.getTableParams(false);
          });
        });
      },
      initCol() {
        this.controllerList.length > 0
        && (this.colList = this.controllerList.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            info.sortableStart = false;
            return info;
          })
        );
      },
    },
    watch: {
      controllerList() {
        this.initCol();
      },
      colList(val) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    },
  };
</script>
<style lang="scss">
  .standing {
    flex: 1;
    display: flex;
    flex-direction: column;
    .el-table .el-table__body-wrapper {
      height: calc(100% - 53px);
    }
    .searchQuery .el-form-item {
      margin-bottom: 0px;
    }
    .el-checkbox-group{
      margin-bottom: 1px;
    }
    .lading_conter_table{
      max-height: 83%;
    }
  }
</style>
